// extracted by mini-css-extract-plugin
module.exports = {"button":"NavigationBarIconButton_button__2UbJV","count":"NavigationBarIconButton_count__2WvDa","badge":"NavigationBarIconButton_badge__3qOdl"};